import React from "react";
import SeoLandingPage from "./SeoLandingPage";

const page = {
  title: "Limassol to Paphos Airport Taxi | Private Airport Transfer",
  description:
    "Book a private taxi from Limassol to Paphos Airport. Reliable 24/7 transfers, fixed price guidance and WhatsApp booking.",
  canonical: "https://limassolairporttaxi.com/limassol-to-paphos-airport-taxi",
  breadcrumbs: [
    { label: "Home", to: "/" },
    { label: "Airport Transfers", to: "/cyprus-airport-transfers" },
    { label: "Limassol to Paphos Airport Taxi" },
  ],
  h1: "Limassol to Paphos Airport Taxi",
  heroText:
    "Travel from Limassol to Paphos Airport in a private taxi with direct pickup, reliable timing, and simple booking for flights west of the city.",
  snapshotLabel: "Guide price",
  snapshotValue: "From EUR75",
  snapshotText:
    "Private transfer from Limassol to Paphos Airport for departures, return flights, holiday travel, and business trips.",
  overviewTitle: "Private transfers from Limassol to Paphos Airport",
  overviewText:
    "Paphos Airport is a convenient choice for many westbound flights and holiday routes. A reserved taxi helps you avoid shuttle delays, parking stress, and last-minute transport uncertainty.",
  overviewCards: [
    {
      label: "Comfort",
      title: "Door-to-door pickup",
      text: "Start from your Limassol address and travel directly to Paphos Airport without changing vehicles or waiting for other passengers.",
    },
    {
      label: "Timing",
      title: "Planned around your flight",
      text: "Pickup timing is arranged around your departure, with allowance for the route, airport check-in, and your travel preferences.",
    },
    {
      label: "Support",
      title: "Clear communication",
      text: "Confirm your taxi details by phone or WhatsApp so you know the pickup time, route, and booking details before travel.",
    },
  ],
  whyTitle: "Why choose our Paphos Airport taxi service",
  whyText:
    "For flights from Paphos Airport, travelers need a dependable transfer that removes guesswork. We keep the booking process direct, practical, and easy to confirm.",
  whyItems: [
    "Direct private transfer from Limassol to Paphos Airport",
    "Suitable for couples, families, residents, and visitors",
    "Helpful for late-night, weekend, and seasonal departures",
    "Simple WhatsApp booking with pickup and luggage details",
  ],
  routesTitle: "Useful Paphos Airport taxi routes",
  routesText:
    "These pages help you book transfer routes in both directions and compare other taxi services from Limassol.",
  popularRoutes: [
    {
      title: "Paphos Airport Taxi",
      to: "/paphos-airport-taxi",
      text: "Taxi transfers between Limassol and Paphos Airport with route pricing and booking options.",
    },
    {
      title: "Paphos Airport to Limassol",
      to: "/paphos-airport-to-limassol",
      text: "Arrival transfer from Paphos Airport to Limassol hotels, apartments, marina, and homes.",
    },
    {
      title: "Taxi Limassol",
      to: "/taxi-limassol",
      text: "Book city taxis, hotel pickups, business rides, and longer taxi journeys from Limassol.",
    },
    {
      title: "Cyprus Airport Transfers",
      to: "/cyprus-airport-transfers",
      text: "Explore airport transfer options for both Cyprus airports and major destination areas.",
    },
  ],
  infoTitle: "Paphos Airport transfer information",
  infoText:
    "The route from Limassol to Paphos Airport is straightforward, but pickup planning matters. Exact journey time can vary by location, traffic, flight schedule, and seasonal airport demand.",
  infoDetails: [
    ["Route", "Limassol to Paphos Airport"],
    ["Service", "Private airport taxi"],
    ["Journey time", "Usually around 45 to 60 minutes"],
    ["Booking", "Phone or WhatsApp"],
    ["Availability", "24/7 by request"],
    ["Best for", "Paphos departures and west Cyprus flights"],
  ],
  availabilityTitle: "24/7 Paphos Airport transfer booking",
  availabilityText:
    "Whether your flight leaves before sunrise or late at night, you can request a Paphos Airport taxi from Limassol with the pickup time matched to your travel schedule.",
  faqTitle: "Limassol to Paphos Airport taxi FAQ",
  faqs: [
    {
      question: "How long is the taxi ride from Limassol to Paphos Airport?",
      answer:
        "Most journeys take around 45 to 60 minutes, depending on your exact pickup address in Limassol, traffic, and airport departure time.",
    },
    {
      question: "What is the price for Limassol to Paphos Airport?",
      answer:
        "The guide price starts from EUR75 for a standard private taxi. Final pricing can vary with pickup area, luggage, passengers, time, and special requirements.",
    },
    {
      question: "Can I book a return transfer from Paphos Airport?",
      answer:
        "Yes. You can arrange both your departure transfer and your return pickup from Paphos Airport to Limassol.",
    },
    {
      question: "Is this transfer private or shared?",
      answer:
        "The service is a private taxi transfer, so you do not wait for unrelated passengers or make shuttle-style stops.",
    },
    {
      question: "Can I book by phone instead of WhatsApp?",
      answer:
        "Yes. You can call directly or use WhatsApp, whichever is easier for confirming your pickup details.",
    },
  ],
};

export default function LimassolToPaphosAirportPage() {
  return <SeoLandingPage page={page} />;
}
